import React from 'react';
import Icon from '../Icon';
import svg from '../icons/add-thick.js';

const IconAddThick = (props) => <Icon {...props} svg={svg} />;

IconAddThick.displayName = 'IconAddThick';

export default IconAddThick;
